import { FilterRowProps } from "../../../components/UtilitiesComponent/FilterRow";
import assest from "../../../json/assest";
// import Image from "next/image";
import React from "react";
import styles from "../../../styles/pages/submithome.module.scss";
import styles1 from "../../../styles/components/SubmittedPageTable/submittedTable.module.scss";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../../components/UtilitiesComponent/Pagination";
import AllPurchasedFilterModal from "../../../components/FilterModal/AllPurchasedFilterModal";
import SubmittedApproveFilter from "../../../components/AllFilterRow/SubmittedPageFilter/SubmittedApproveFilter";
import { useNavigate } from "react-router";
import SubmittedApprovedFilterModal from "../../FilterModal/SubmittedApprovedFilterModal ";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import SubmittedWebsiteFilter from "../../AllFilterRow/SubmittedPageFilter/SubmittedWebsiteFilter";
import SubmittedWebsiteFilterModal from "../../FilterModal/SubmittedWebsiteFilterModal";
import PaginationTwo from "../../UtilitiesComponent/PaginationTwo";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

function createData(
  VSID,
  Acquisitor,
  Thumbnail,
  Title,
  SubmitterName,
  EmailAddress,
  SubmissionDate,
  Inquirer
) {
  return {
    VSID,
    Acquisitor,
    Thumbnail,
    Title,
    SubmitterName,
    EmailAddress,
    SubmissionDate,
    Inquirer,
  };
}

const rows = [
  createData(
    "13194",
    <>Theodore</>,
    <>
      <img src={assest.tabthumbnail1} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Me, Myself & I <br /> <span>Admin</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={assest.tabthumbnail2} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Jason Marcel <br /> <span>QC Agent</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Muhammad Ali Waqas</>,
    <>
      <img src={assest.tabthumbnail3} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Theodore Doulkeris</>,
    <>
      <img src={assest.tabthumbnail4} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={assest.tabthumbnail5} width={73} height={46} alt="" />
    </>,
    "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Me, Myself & I <br /> <span>Admin</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={assest.tabthumbnail6} width={73} height={46} alt="" />
    </>,
    "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={assest.tabthumbnail7} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={assest.tabthumbnail8} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail9} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Jason Marcel <br /> <span>QC Agent</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail10} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Me, Myself & I <br /> <span>Admin</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail11} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail12} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail13} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={assest.tabthumbnail14} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Me, Myself & I <br /> <span>Admin</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={assest.tabthumbnail15} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>Awaiting Confirmation</>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={assest.tabthumbnail16} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={assest.tabthumbnail17} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={assest.tabthumbnail18} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={assest.tabthumbnail19} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={assest.tabthumbnail20} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
];

export default function SubmittedWebsiteTable(props) {
  const {
    filterRowProps,
    datas,
    handlePageChange,
    filterRefetch,
    page,
    p,
    handleClearFilterModal,
    confirmed,
  } = props;
  // const route = useNavigate();

  return (
    <Box className={`${styles.table_sec} ${styles.submitTable}`}>
      <Box className={styles.table_top}>
        <SubmittedWebsiteFilter
          {...filterRowProps}
          FilterModalComponent={SubmittedWebsiteFilterModal}
          filterModalProps={{
            hideBottom: true,
            filterRefetch,
            handleClearFilterModal,
            p,
          }}
        />
      </Box>
      <Box className={`${styles.table_main} ${styles1.submitApproveTable}`}>
        <PerfectScrollbar>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={styles1.visd}>VSID</TableCell>
                  <TableCell className={styles1.acqui}>Acquisitor</TableCell>
                  <TableCell className={styles1.thumb}>Thumbnail</TableCell>
                  <TableCell className={styles1.title}>Title</TableCell>
                  <TableCell className={styles1.submitter}>
                    Submitter Name
                  </TableCell>
                  <TableCell className={styles1.email}>Email Address</TableCell>
                  <TableCell className={styles1.submission}>
                    Submission Date
                  </TableCell>
                  <TableCell className={styles1.approved}>Marked by</TableCell>
                  <TableCell className={styles1.view}>View</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {datas?.data.map((row) => (
                  <TableRow key={row.VSID}>
                    <TableCell>
                      <Box className={styles.vsid_code}>
                        {/* <img
                                                src={assest.infoicon}
                                                width={3}
                                                height={18}
                                                alt=""
                                            />{" "} */}
                        <p>{row.id}</p>
{row.unseen_messages ? (
<span className={styles.vsid_circ}></span>
) : (
<></>
)}

                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.acquisitor}>
                        {" "}
                        {row.user?.name} {row.user?.last_name}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <figure className={styles.thumb_img}>
                        <img
                          className={styles.thumb_img}
                          src={concatHostAndImagePath(row.thumbnail)}
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>
                      {row.first_name} {row.last_name}
                    </TableCell>
                    <TableCell>
                      {row.email}
                      {row.unreachable_submitter ? (
                        <p className={styles.red_email}>Unreachable Email</p>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell>{getUtcDate(row.created_at)} <br />{getUtcTime(row.created_at)}</TableCell>
                    <TableCell
                      className={`${!confirmed ? styles1.inquirerBoxActive : ""}`}
                    >
                      <Box className={styles1.inquirerBox}>
                        {confirmed ? (
                          <>
                            {row.manager?.name}
                            <br /> <span>Manager</span> <br />
                            <strong>
                              {" "}
                              {row.video_meta.manager_updated_at
                                ? `${getUtcDateTime(
                                  row.video_meta.manager_updated_at
                                )}`
                                : ""}
                            </strong>
                          </>
                        ) : (
                          <>Awaiting Confirmation</>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Link
                        to={`/video/${row.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box className={styles.table_view}>
                          <img
                            src={assest.tableview}
                            width={16}
                            height={16}
                            alt=""
                          />
                        </Box>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
                {/* <TableRow>
                                <TableCell colSpan={10} className={styles.blanktd}>
                                    {" "}
                                </TableCell>
                            </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
        {/* <Pagination
          lastpage={datas.last_page}
          //   onClick={handlePageChange}
          sendDataToParent={handlePageChange}
        /> */}
        <PaginationTwo
          count={datas.last_page}
          handleChange={handlePageChange}
          page={page}
        />

        {/* <Pagination lastpage={undefined} onClick={undefined} sendDataToParent={undefined} /> */}
      </Box>
    </Box>
  );
}
